var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputCounter = void 0;
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var React = __importStar(require("react"));
var TextField_1 = require("../TextField");
var InputCounter = function (_a) {
    var value = _a.value, className = _a.className, onChange = _a.onChange;
    return (React.createElement(TextField_1.TextField, { color: "secondary", value: value, className: className, type: "number", onChange: onChange }));
};
exports.InputCounter = InputCounter;
exports.default = exports.InputCounter;
//# sourceMappingURL=InputCounter.js.map